import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createLinkStyles = ({ palette, typography }: Theme) => {
  return {
    root: css({
      fontSize: "inherit",
      fontWeight: typography.fontWeight.semiBold,
      color: palette.default.text,
      "&:hover, &:focus": {
        color: grey[800],
      },
      "&:active": {
        color: grey[900],
      },
    }),
    disabled: css({
      cursor: "not-allowed",
      color: grey[600],
      textDecoration: "underline",
    }),
  };
};
